export class Tenant {
	public id: string;
	public name: string;
	public address: string;
	public createdDate: Date;
}
